<template>
  <v-dialog
    :model-value="true"
    max-width="720"
    @update:model-value="handleDialogModelUpdate"
  >
    <v-card
      rounded="xl"
      class="modal-card"
    >
      <v-btn
        icon="nf nf-md-close"
        variant="text"
        size="small"
        class="modal-card__close"
        @click="handleClose"
      />

      <template v-if="config.component">
        <v-card-title
          v-if="config.title"
          class="modal-card__title"
        >
          {{ config.title }}
        </v-card-title>
        <v-card-text
          v-if="config.message"
          class="modal-card__message"
        >
          {{ config.message }}
        </v-card-text>
        <v-card-text class="modal-card__body">
          <component
            :is="config.component"
            v-bind="config.componentProps"
            @close="handleClose"
          />
        </v-card-text>
      </template>

      <template v-else>
        <v-card-text class="modal-card__message-box has-text-centered">
          <div
            class="icon-circle is-flex is-align-items-center is-justify-content-center mb-4"
            :class="['border-' + computedType, 'has-text-' + computedType]"
          >
            <span class="icon is-large">
              <i :class="'fa-solid fa-' + computedIcon + ' fa-2xl'"></i>
            </span>
          </div>

          <p
            v-if="config.title"
            class="title is-4"
          >
            {{ config.title }}
          </p>
          <p
            v-if="config.message"
            class="subtitle is-6"
          >
            {{ config.message }}
          </p>
          <p
            v-if="config.subMessage"
            class="subtitle is-7 has-text-grey"
          >
            {{ config.subMessage }}
          </p>
        </v-card-text>

        <v-card-actions
          v-if="config.buttons"
          class="modal-card__actions"
        >
          <v-btn
            v-for="(btn, index) in config.buttons"
            :key="index"
            :class="btn.class"
            @click="handleButton(btn)"
          >
            {{ btn.label }}
          </v-btn>
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  config: {
    type: Object,
    required: true
  }
});
const emit = defineEmits(['close', 'buttonAction']);

const computedType = computed(() =>
  props.config.type === 'danger' || props.config.type === 'success'
    ? props.config.type
    : 'info'
);

const computedIcon = computed(() => {
  if (props.config.type === 'danger') {
    return 'xmark';
  }
  if (props.config.type === 'success') {
    return 'check';
  }
  return 'info';
});

function handleDialogModelUpdate(isOpen) {
  if (isOpen) return;
  handleClose();
}

function handleClose() {
  emit('close');
}

function handleButton(btn) {
  emit('buttonAction', btn);
}
</script>

<style scoped>
.modal-card {
  position: relative;
  overflow: visible;
}

.modal-card__close {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  z-index: 2;
}

.modal-card__title {
  padding-right: 3rem;
  padding-bottom: 0;
}

.modal-card__message {
  padding-top: 0.25rem;
  padding-bottom: 0;
  color: rgba(17, 24, 39, 0.72);
}

.modal-card__body {
  padding-top: 1rem;
}

.modal-card__message-box {
  padding-top: 2rem;
}

.modal-card__actions {
  justify-content: center;
  padding: 0 1.5rem 1.5rem;
}

.icon-circle {
  width: 80px;
  height: 80px;
  border: 4px solid;
  border-radius: 50%;
  margin: 0 auto;
}

.border-danger {
  border-color: #ff3860;
}

.border-success {
  border-color: #23d160;
}

.border-info {
  border-color: #209cee;
}
</style>
